export enum NavItemType {
  Text,
  Link,
  Button,
  Profile,
  Email,
  Phone,
}
